import {SETTING_CHANGE_blogExpanded, INITIAL, CALC_OBJECT} from "./types";
import {BLOG_IN_HEADER} from "./types";
import {EXPANDED_IN_HEADER} from "./types";


export const settingMines = (value) => {
    return {
        type: SETTING_CHANGE_blogExpanded,
        payload:value
    };
};

export const settingMinesHeader = (value) => {
    return {
        type: EXPANDED_IN_HEADER,
        payload:value
    };
};

export const setInitial = (value) => {
    return {
        type: INITIAL,
        payload:value
    };
};

export const setCalcObject = (value) => {
    return {
        type: CALC_OBJECT,
        payload:value
    };
};

export const settingPlus = (value) => {
    return {
        type: SETTING_CHANGE_blogExpanded,
        payload:value
    };
};

export const handleBlogInHead = (value) => {
    return {
        type: BLOG_IN_HEADER,
        payload:value
    };
};
